import type { ProductConfig } from '../../default/product/product.types';
import type { DeepPartial } from '../../default/types';

export const productConfig: DeepPartial<ProductConfig> = {
  activeABTests: { installmentCalculatorCallToAction: '2026_1_payment_calculator' },
  cliplister: {
    customerId: '80936',
  },
  recommendations: {
    dv: {
      slots: {
        '3': 'miraklProducts',
      },
    },
  },
};
